import { useCallback } from 'react';
import { Card, Stack, Text } from '@tiendanube/components';
import { CopyLink } from 'commons/components';
import SendWhatsAppLink from 'commons/components/SendWhatsAppLink';
import { trackingOrderAbandonedCartSendWhatsappClick } from 'domains/Orders/tracking';
import useTranslationOrders from 'domains/Orders/useTranslationOrders/useTranslationOrders';
import ShareAbandonedCartCardSkeleton from './ShareAbandonedCartCardSkeleton';

interface CardShareAbandonedCartProps {
  ulrAbanadonedCart: string;
  phoneCustomer: string;
  nameClient: string;
  nameStore: string;
  cartId: string;
}

function ShareAbandonedCartCard({
  ulrAbanadonedCart,
  phoneCustomer,
  nameClient,
  nameStore,
  cartId,
}: CardShareAbandonedCartProps) {
  const t = useTranslationOrders();
  const handleClickTrack = useCallback(
    () => trackingOrderAbandonedCartSendWhatsappClick(cartId),
    [cartId],
  );

  return (
    <Card title={t('abandonedCarts.cardShareAbandonedCart.title')}>
      <Stack column align="stretch" spacing="tight">
        <Text>{t('abandonedCarts.cardShareAbandonedCart.text')}</Text>
        <Stack>
          <CopyLink
            value={ulrAbanadonedCart}
            message={t('abandonedCarts.cardShareAbandonedCart.copyLinkMessage')}
            text={t('abandonedCarts.cardShareAbandonedCart.copyLinkText')}
            iconPosition="start"
          />
          <SendWhatsAppLink
            textWhatsapp={t('abandonedCarts.sendEmail.body', {
              nameClient,
              nameStore,
              interpolation: { escapeValue: false },
            })}
            phoneNumber={phoneCustomer}
            textChild={t(
              'abandonedCarts.cardShareAbandonedCart.whatsAppSendText',
            )}
            url={ulrAbanadonedCart}
            onClickTrack={handleClickTrack}
          />
        </Stack>
      </Stack>
    </Card>
  );
}

ShareAbandonedCartCard.Skeleton = ShareAbandonedCartCardSkeleton;

export default ShareAbandonedCartCard;
